// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"login_wrapper__22O7i","form":"login_form__3t0Xi","group":"login_group__79Fy6","button":"login_button__KZrsb"};